<app-decor class="block-finder__decor" type="bottom"></app-decor>
<div
    class="block-finder__image"
    style="background-image: url(https://bangaloreeducationservices.com/wp-content/uploads/2016/11/banner-student-groups2.jpg);"
></div>
<div class="block-finder__body container container--max--xl">
    <div class="block-finder__title">FIND WHAT YOU NEED!
        </div>
    <div class="block-finder__subtitle">Discover top rated univesities & colleges</div>
    <form class="block-finder__form" (submit)="submit()">
        <app-vehicle-select class="block-finder__select" (data)="data($event)" [formControl]="vehicleControl"></app-vehicle-select>

        <button class="block-finder__button" [disabled]="!valid" type="submit">{{ 'BUTTON_BLOCK_FINDER_SEARCH'|translate }}</button>
    </form>
</div>
